import { z } from "zod";

import { basePrayerSchema } from "./prayer/basePrayerSchema";

export const journalSchema = z.object({
  id: z.number(),
  prayer: basePrayerSchema.nullable(),
  prayer_id: z.number().nullable(),
  sync_uuid: z.string(),
  title: z.string(),
  entry: z.string(),
  sharing_to: z.number().array(),
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
});

export const allJournalSchema = journalSchema.array();

export type Journal = z.infer<typeof journalSchema>;
export type AllJournals = z.infer<typeof allJournalSchema>;
